function Komplainopt() {
  return <div>Komplainopt</div>
}

export default Komplainopt
